import React from 'react';

import { AnimatePresence, type HTMLMotionProps } from 'framer-motion';

import { type ActivityFeedType } from '../../hooks/useDaasActivity';

import { BellIcon, Border, Button, Count, HandIcon, Icon, Pulse, Shadow, Wrapper } from './styles';

export type MinimizedProps = HTMLMotionProps<'div'> & {
    handleToggle: () => void;
} & Pick<ActivityFeedType, 'notificationCount' | 'notificationFeed' | 'addingNewNotifications'>;

export const Minimized = ({
    handleToggle,
    notificationCount,
    addingNewNotifications,
    notificationFeed,
    ...props
}: MinimizedProps) => {
    const hasNotification = notificationFeed.length !== 0;

    /*
    const getLabel = (notification: NotificationType) => {
        switch (notification.transactionType) {
            case ActivityStatusType.Buy:
                return `Bought for ${notification.value} ${notification.currency}`;
            case ActivityStatusType.Bid:
                return `Bid ${notification.value} ${notification.currency}`;
            case ActivityStatusType.Listed:
                return `Listed ${notification.currency}`;
            case ActivityStatusType.Transfer:
                return `Transfer ${notification.currency}`;
            case ActivityStatusType.Mint:
                return `Mint ${notification.currency}`;
            case ActivityStatusType.Offer:
                return `Offer ${notification.value} ${notification.currency}`;
            default:
                return `Bought for ${notification.value} ${notification.currency}`;
        }
    };
    */

    return (
        <Wrapper {...props}>
            <Pulse $hasNotification={hasNotification}>
                <Border $hasNotification={hasNotification}>
                    {/*}
                    <Notifications>
                        <AnimatePresence initial={false}>
                            {addingNewNotifications &&
                                notificationFeed.slice(0, 3).map((notification) => (
                                    <Notification
                                        onClick={handleToggle}
                                        initial={{ y: '100%', scale: 0.5 }}
                                        animate={{ y: -20, scale: 1 }}
                                        transition={{ duration: 0.3 }}
                                        // exit={{ x: '100%' }}
                                        key={`activity-notification-${notification.tokenId}-${notification.value}-${notification.uuid}`}
                                        layout="position"
                                    >
                                        <NotificationImage $image={notification.image} />
                                        <NotificationText>
                                            <span>{getLabel(notification)}</span>
                                        </NotificationText>
                                    </Notification>
                                ))}
                        </AnimatePresence>
                    </Notifications>
                    {*/}

                    <AnimatePresence initial={false}>
                        {notificationCount && (
                            <Count initial={{ scale: 0 }} animate={{ scale: 1 }} exit={{ scale: 0 }}>
                                {notificationCount}
                            </Count>
                        )}
                    </AnimatePresence>

                    <Button onClick={handleToggle} $hasNotification={hasNotification}>
                        <AnimatePresence initial={false}>
                            {!hasNotification && (
                                <Icon
                                    initial={{ y: '100%' }}
                                    animate={{ y: 0 }}
                                    exit={{ y: '-100%' }}
                                    transition={{ type: 'spring', damping: 20, stiffness: 300 }}
                                >
                                    <HandIcon />
                                </Icon>
                            )}
                        </AnimatePresence>
                        <AnimatePresence initial={false}>
                            {hasNotification && (
                                <Icon
                                    initial={{ y: '100%' }}
                                    animate={{ y: 0 }}
                                    exit={{ y: '-100%' }}
                                    transition={{ type: 'spring', damping: 20, stiffness: 300 }}
                                >
                                    <BellIcon />
                                </Icon>
                            )}
                        </AnimatePresence>
                    </Button>
                </Border>
            </Pulse>

            <Shadow />
        </Wrapper>
    );
};
